export const translations = {
  it: {
    nav: {
      about: "Azienda",
      services: "Servizi",
      projects: "Lavori",
      certifications: "Certificazioni",
      contact: "Contatti",
      cta: "Richiedi preventivo",
    },
    tabs: {
      home: "Home",
      azienda: "Azienda",
      risorse: "Risorse",
      servizi: "Servizi",
      lavori: "Lavori",
      certificazioni: "Certificazioni",
      partner: "Partner",
      contatti: "Contatti",
      privacy: "Privacy",
    },
    seo: {
      home: {
        title: "I.E.P.E.M. S.r.l. | Impresa di Costruzioni a Perugia dal 1982",
        description: "I.E.P.E.M. S.r.l. realizza opere edili, stradali ed elettromeccaniche chiavi in mano dal 1982: stazioni di servizio, ristorazione, edilizia e infrastrutture in tutta Italia.",
      },
      azienda: {
        title: "Azienda | I.E.P.E.M. S.r.l.",
        description: "Dal 1982 I.E.P.E.M. unisce esperienza, qualità e sicurezza in cantieri chiavi in mano per privati, imprese ed enti pubblici.",
      },
      risorse: {
        title: "Risorse | I.E.P.E.M. S.r.l.",
        description: "Oltre 40 professionisti, squadre specializzate e capo cantieri operativi per gestire lavori in ogni regione d'Italia.",
      },
      servizi: {
        title: "Servizi | I.E.P.E.M. S.r.l.",
        description: "General contractor per stazioni di servizio, aree di ristoro, edilizia civile e industriale, infrastrutture e lottizzazioni.",
      },
      lavori: {
        title: "Lavori Realizzati | I.E.P.E.M. S.r.l.",
        description: "Una selezione di cantieri realizzati per compagnie petrolifere, brand della ristorazione, privati ed enti pubblici.",
      },
      certificazioni: {
        title: "Certificazioni | I.E.P.E.M. S.r.l.",
        description: "Certificazioni ISO 9001, attestazioni SOA e qualifiche che documentano qualità, sicurezza e affidabilità I.E.P.E.M.",
      },
      partner: {
        title: "Partner e Clienti | I.E.P.E.M. S.r.l.",
        description: "Le principali compagnie petrolifere e brand della ristorazione scelgono I.E.P.E.M. per progetti complessi in tutta Italia.",
      },
      contatti: {
        title: "Contatti | I.E.P.E.M. S.r.l. Perugia",
        description: "Contatta I.E.P.E.M. S.r.l. a Perugia per valutare il tuo progetto edile, stradale o elettromeccanico chiavi in mano.",
      },
      privacy: {
        title: "Privacy Policy | I.E.P.E.M. S.r.l.",
        description: "Consulta le informative privacy di I.E.P.E.M. S.r.l. per clienti e fornitori, redatte ai sensi del GDPR.",
      },
    },
    values: {
      label: "Manifesto",
      title: "I valori che tengono in piedi ogni cantiere.",
    },
    policies: {
      label: "Le nostre politiche",
      title: "Qualità, sicurezza e ambiente",
    },
    risorse: {
      label: "Le nostre risorse",
      title: "Squadre specializzate, copertura nazionale",
      intro: "Il nostro organico tecnico-operativo, strutturato in squadre specializzate, garantisce interventi rapidi ed efficienti su tutto il territorio nazionale, gestendo in autonomia ogni fase del cantiere.",
      cols: ["Settore", "Professionalità", "N."],
      numbersTitle: "Numeri che parlano di persone",
      numbersText: "Oltre 40 persone in organico, 2 ingegneri in staff tecnico, 7 capo cantieri operativi e una copertura che raggiunge ogni regione d'Italia.",
    },
    partner: {
      label: "Partner e clienti",
      title: "Relazioni di fiducia costruite negli anni",
      intro: "Negli anni I.E.P.E.M. ha costruito relazioni di fiducia con le principali compagnie petrolifere e i più importanti brand della ristorazione italiana, diventando partner di riferimento per progetti complessi su tutto il territorio nazionale.",
      clientsTitle: "Alcuni dei nostri clienti",
    },
    lavori: {
      label: "Alcuni dei lavori realizzati",
      soon: "Foto in arrivo",
    },
    hero: {
      kicker: "Impresa di costruzioni · Perugia",
      line1: "Costruiamo fiducia,",
      line2: "cantiere dopo",
      line3: "cantiere,",
      lastLine: "dal 1982.",
      intro:
        "Impresa di costruzioni con oltre quarant'anni di esperienza. Dalla ricostruzione post-sisma alle grandi infrastrutture stradali e alle stazioni di servizio, realizziamo opere chiavi in mano con serietà, qualità e sicurezza.",
      ctaPrimary: "Scopri i progetti",
      ctaSecondary: "Contattaci",
      scroll: "Scroll",
    },
    stats: {
      title: "Numeri che raccontano",
      subtitle: "Quarant'anni di cantieri, un solo modo di lavorare.",
      founded: "Anno di fondazione",
      people: "Dipendenti e collaboratori",
      iso: "Certificazione Bureau Veritas",
      soa: "Attestazione SOA",
      turnkey: "Chiavi in mano",
      intervention: "Tempo di intervento",
      national: "Copertura nazionale",
    },
    about: {
      label: "L'Azienda",
      title: "Storia, obiettivi e missione",
      p1: "I.E.P.E.M. S.r.l. è stata fondata nel 1982 dai Sig.ri Baiocco Renato e Roscini Mario. Il Sig. Baiocco Renato operava già da anni nella ristrutturazione e manutenzione di edifici di civile abitazione, specializzandosi nella ricostruzione post-terremoto di Norcia. Dall'incontro con il Geom. Roscini Mario nasce I.E.P.E.M. snc, poi trasformata nell'attuale I.E.P.E.M. S.r.l.: grazie all'esperienza nel settore carburanti, la società estende il suo campo di azione nella costruzione, ristrutturazione e manutenzione di impianti carburanti.",
      p2: "Nel novembre 2021, in ottica di crescita evolutiva, un cambio generazionale e un riassetto societario hanno visto l'ingresso di due nuove figure ai vertici: il Sig. Davide Baiocco (Amministratore Unico) e la Sig.ra Maria Teresa Ceccarelli, pronti entrambi a portare avanti la Missione e la Visione di IEPEM. I soci fondatori, i Sig.ri Baiocco Renato e Roscini Mario, rimangono all'interno della società continuando a portare il valore dato dall'esperienza e dai risultati ottenuti negli anni.",
      p3: "Oggi I.E.P.E.M. conta oltre 40 lavoratori tra dipendenti e collaboratori esterni, con uno staff tecnico qualificato e squadre organizzate in grado di seguire più cantieri contemporaneamente su tutto il territorio nazionale. Grazie alla qualità dimostrata, l'azienda collabora con le principali compagnie petrolifere e i più importanti brand della ristorazione italiana, aggiudicandosi un posto nelle liste di invito private.",
      missionLabel: "Missione e valori",
      mission:
        "Crediamo che un'azienda sia una famiglia e che onestà, rispetto, contribuzione e passione siano la base di ogni traguardo. Portiamo valore a individui, aziende e comunità in ogni sfida in cui decidiamo di credere.",
      quote:
        "«Alcune persone vedono un'impresa privata come una tigre feroce da uccidere subito, altri come una mucca da mungere; pochissimi la vedono com'è in realtà: un robusto cavallo che traina un carro molto pesante.»",
    },
    services: {
      label: "I nostri servizi",
      title: "Un unico interlocutore, dalla progettazione alla consegna",
      intro:
        "Acquisiamo commesse con la formula general contractor, coprendo in autonomia tutte le fasi lavorative necessarie al compimento dell'opera.",
      turnkeyLabel: "Servizio completo",
      turnkeyTitle: "Chiavi in mano",
      turnkeyText:
        "Squadre organizzate seguono più cantieri contemporaneamente su tutto il territorio nazionale, gestendo in autonomia ogni fase — con la qualità che ci ha aperto le liste di invito private delle principali committenze.",
    },
    projects: {
      label: "Alcuni dei lavori realizzati",
      title: "Opere che parlano per noi",
      intro:
        "Interventi chiavi in mano per i principali operatori del settore petrolifero, della ristorazione e per enti pubblici, su tutto il territorio nazionale.",
      all: "Tutti",
      viewCaption: "Vista",
      close: "Chiudi",
    },
    certifications: {
      label: "Certificazioni e qualificazioni",
      title: "Standard attestati, in corso di validità",
      intro:
        "Operiamo nel pieno rispetto degli standard di qualità, sicurezza e tutela ambientale richiesti dal settore delle costruzioni e degli impianti.",
      soaTitle: "Attestazione SOA — La Soatech S.p.A.",
      soaCols: ["Categoria", "Descrizione", "Classifica"],
      isoTitle: "Certificazioni di qualità — Bureau Veritas",
      isoText:
        "ISO 9001:2015 dal 1999 — Costruzione e manutenzione di impianti di distribuzione carburante, con relativi lavori stradali, fognari e di installazione di impianti elettromeccanici.",
      qualTitle: "Qualificazioni legali e di registro",
    },
    clients: {
      label: "Partner e clienti",
      title: "Relazioni di fiducia costruite negli anni",
    },
    contact: {
      label: "Contatti",
      title: "Parliamo del vostro progetto",
      intro:
        "Contattateci per una consulenza senza impegno: valutiamo insieme fattibilità, tempi e formula più adatta.",
      companyName: "Ragione Sociale",
      activity: "Attività",
      activityValue: "Opere Edili — Stradali — Elettromeccaniche",
      ceo: "Amministratore Unico",
      techDirector: "Direttore Tecnico",
      rea: "Numero REA",
      address: "Sede Legale e Operativa",
      phone: "Telefono",
      email: "Email",
      pec: "PEC",
      vat: "P. IVA / C.F.",
      callCta: "Chiama ora",
      emailCta: "Scrivici una email",
      careersLabel: "Lavora con noi",
      careersText: "Vuoi entrare a far parte del nostro team? Inviaci la tua candidatura.",
      careersCta: "Invia candidatura",
      rights: "Tutti i diritti riservati.",
      builtWith: "Costruiamo fiducia, cantiere dopo cantiere, dal 1982.",
    },
    privacy: {
      label: "Informativa",
      title: "Privacy policy",
      intro: "In queste pagine descriviamo le modalità di trattamento dei dati personali, in linea con il Regolamento (UE) 2016/679 (GDPR). Sono disponibili due informative: una per i clienti e una per i fornitori.",
      choose: "Seleziona informativa",
      contactLabel: "Referente privacy",
      contactIntro: "Per qualsiasi richiesta relativa al trattamento dei dati personali:",
      download: "Scarica PDF",
      updated: "Ultimo aggiornamento",
    },
  },

  en: {
    nav: {
      about: "Company",
      services: "Services",
      projects: "Work",
      certifications: "Certifications",
      contact: "Contact",
      cta: "Request a quote",
    },
    tabs: {
      home: "Home",
      azienda: "Company",
      risorse: "Resources",
      servizi: "Services",
      lavori: "Work",
      certificazioni: "Certifications",
      partner: "Partners",
      contatti: "Contact",
      privacy: "Privacy",
    },
    seo: {
      home: {
        title: "I.E.P.E.M. S.r.l. | Construction Company in Perugia since 1982",
        description: "I.E.P.E.M. S.r.l. delivers turnkey building, road and electromechanical works: service stations, catering, civil construction and infrastructure across Italy.",
      },
      azienda: {
        title: "Company | I.E.P.E.M. S.r.l.",
        description: "Since 1982, I.E.P.E.M. has combined experience, quality and safety in turnkey projects for private clients, businesses and public bodies.",
      },
      risorse: {
        title: "Resources | I.E.P.E.M. S.r.l.",
        description: "Over 40 professionals, specialised teams and operational site managers delivering projects across every region of Italy.",
      },
      servizi: {
        title: "Services | I.E.P.E.M. S.r.l.",
        description: "General contractor for service stations, catering areas, civil and industrial construction, infrastructure and development works.",
      },
      lavori: {
        title: "Completed Work | I.E.P.E.M. S.r.l.",
        description: "A selection of construction projects delivered for fuel companies, catering brands, private clients and public bodies.",
      },
      certificazioni: {
        title: "Certifications | I.E.P.E.M. S.r.l.",
        description: "ISO 9001 certification, SOA attestation and qualifications documenting I.E.P.E.M.'s quality, safety and reliability.",
      },
      partner: {
        title: "Partners & Clients | I.E.P.E.M. S.r.l.",
        description: "Leading fuel companies and catering brands choose I.E.P.E.M. for complex construction projects throughout Italy.",
      },
      contatti: {
        title: "Contact | I.E.P.E.M. S.r.l. Perugia",
        description: "Contact I.E.P.E.M. S.r.l. in Perugia to discuss your turnkey building, road or electromechanical project.",
      },
      privacy: {
        title: "Privacy Policy | I.E.P.E.M. S.r.l.",
        description: "Read the GDPR privacy notices issued by I.E.P.E.M. S.r.l. for clients and suppliers.",
      },
    },
    values: {
      label: "Manifesto",
      title: "The values that hold every site together.",
    },
    policies: {
      label: "Our policies",
      title: "Quality, safety and environment",
    },
    risorse: {
      label: "Our resources",
      title: "Specialised teams, national coverage",
      intro: "Our technical and operational workforce, organised into specialised teams, ensures fast and efficient interventions across the country, managing every phase of the site independently.",
      cols: ["Sector", "Role", "No."],
      numbersTitle: "Numbers that speak of people",
      numbersText: "Over 40 people on staff, 2 engineers in the technical team, 7 operational site managers and coverage reaching every region of Italy.",
    },
    partner: {
      label: "Partners & clients",
      title: "Relationships of trust built over the years",
      intro: "Over the years I.E.P.E.M. has built relationships of trust with leading oil companies and the most important Italian catering brands, becoming a reference partner for complex projects across the country.",
      clientsTitle: "Some of our clients",
    },
    lavori: {
      label: "Selected completed works",
      soon: "Photo coming soon",
    },
    hero: {
      kicker: "Construction company · Perugia",
      line1: "We build trust,",
      line2: "site after",
      line3: "site,",
      lastLine: "since 1982.",
      intro:
        "A construction company with over forty years of experience. From post-earthquake reconstruction to major road infrastructure and service stations, we deliver turnkey works with reliability, quality and safety.",
      ctaPrimary: "Discover the projects",
      ctaSecondary: "Contact us",
      scroll: "Scroll",
    },
    stats: {
      title: "Numbers that tell a story",
      subtitle: "Forty years of building sites, one single way of working.",
      founded: "Year founded",
      people: "Employees & collaborators",
      iso: "Bureau Veritas certification",
      soa: "SOA attestation",
      turnkey: "Turnkey",
      intervention: "Response time",
      national: "National coverage",
    },
    about: {
      label: "The Company",
      title: "History, goals and mission",
      p1: "I.E.P.E.M. S.r.l. was founded in 1982 by Renato Baiocco and Mario Roscini. Renato Baiocco had already worked for years in the renovation and maintenance of residential buildings, specialising in the post-earthquake reconstruction of Norcia. From his meeting with surveyor Mario Roscini, I.E.P.E.M. snc was born — later becoming today's I.E.P.E.M. S.r.l.: drawing on its experience in the fuel sector, the company extended its scope to the construction, renovation and maintenance of fuel stations.",
      p2: "In November 2021, with a view to evolutionary growth, a generational change and corporate reorganisation brought two new figures to the helm: Davide Baiocco (Sole Director) and Maria Teresa Ceccarelli, both ready to carry forward IEPEM's Mission and Vision. The founding partners, Renato Baiocco and Mario Roscini, remain within the company, continuing to bring the value of their experience and the results achieved over the years.",
      p3: "Today I.E.P.E.M. employs over 40 people between staff and external collaborators, with a qualified technical team and organised crews able to follow multiple sites simultaneously across the country. Thanks to its proven quality, the company works with leading oil companies and the most important Italian catering brands, earning a place on their private invitation lists.",
      missionLabel: "Mission & values",
      mission:
        "We believe a company is a family, and that honesty, respect, contribution and passion are the foundation of every goal. We bring value to individuals, companies and communities in every challenge we choose to believe in.",
      quote:
        "\"Some see a private enterprise as a fierce tiger to be shot at once, others as a cow to be milked; very few see it as it really is: a strong horse pulling a very heavy wagon.\"",
    },
    services: {
      label: "Our services",
      title: "A single partner, from design to delivery",
      intro:
        "We take on projects as a general contractor, independently covering every phase of work required to complete the job.",
      turnkeyLabel: "Complete service",
      turnkeyTitle: "Turnkey",
      turnkeyText:
        "Organised crews follow multiple sites simultaneously across the country, managing every phase independently — with the quality that opened the private invitation lists of the leading clients.",
    },
    projects: {
      label: "Selected completed works",
      title: "Work that speaks for us",
      intro:
        "Turnkey interventions for leading players in the fuel and catering sectors and for public bodies, throughout Italy.",
      all: "All",
      viewCaption: "View",
      close: "Close",
    },
    certifications: {
      label: "Certifications & qualifications",
      title: "Attested standards, currently valid",
      intro:
        "We operate in full compliance with the quality, safety and environmental standards required by the construction and plant sector.",
      soaTitle: "SOA attestation — La Soatech S.p.A.",
      soaCols: ["Category", "Description", "Class"],
      isoTitle: "Quality certifications — Bureau Veritas",
      isoText:
        "ISO 9001:2015 since 1999 — Construction and maintenance of fuel distribution plants, including related road, sewer and electromechanical installation works.",
      qualTitle: "Legal and registry qualifications",
    },
    clients: {
      label: "Partners & clients",
      title: "Relationships of trust built over the years",
    },
    contact: {
      label: "Contact",
      title: "Let's talk about your project",
      intro:
        "Get in touch for a no-obligation consultation: together we'll assess feasibility, timelines and the best approach.",
      companyName: "Company name",
      activity: "Activity",
      activityValue: "Building — Road — Electromechanical Works",
      ceo: "Sole Director",
      techDirector: "Technical Director",
      rea: "REA Number",
      address: "Registered & operational office",
      phone: "Phone",
      email: "Email",
      pec: "Certified email (PEC)",
      vat: "VAT / Tax code",
      callCta: "Call now",
      emailCta: "Send us an email",
      careersLabel: "Work with us",
      careersText: "Would you like to join our team? Send us your application.",
      careersCta: "Send application",
      rights: "All rights reserved.",
      builtWith: "We build trust, site after site, since 1982.",
    },
    privacy: {
      label: "Notice",
      title: "Privacy policy",
      intro: "On these pages we describe how personal data is handled, in accordance with Regulation (EU) 2016/679 (GDPR). Two notices are available: one for clients and one for suppliers. The full text of the legal notice is provided in Italian.",
      choose: "Choose notice",
      contactLabel: "Privacy contact",
      contactIntro: "For any request regarding the processing of personal data:",
      download: "Download PDF",
      updated: "Last update",
    },
  },
};
